// Web-only bridge: shell `openImageEditor` → direct multipart upload in WebChatRoom.

import type { ImageSource } from '@ping/ui';

export type WebImageUploadFn = (files: ReadonlyArray<File>) => Promise<void>;

let uploadFn: WebImageUploadFn | null = null;

export function registerWebImageUpload(fn: WebImageUploadFn | null): void {
  uploadFn = fn;
}

export function uploadImageSources(sources: readonly ImageSource[]): void {
  if (uploadFn === null) return;
  const files: File[] = [];
  for (const source of sources) {
    if (source.blob instanceof File) {
      files.push(source.blob);
    } else {
      files.push(
        new File([source.blob], `image-${source.id}.jpg`, {
          type: source.blob.type !== '' ? source.blob.type : 'image/jpeg',
        }),
      );
    }
  }
  if (files.length > 0) {
    void uploadFn(files);
  }
}
